import { isGoGameEnv } from 'App/constants';

import { creativeFiltersSchema } from 'scenes/Trackers/CreativeFilters/schemas';

import {
  object,
  number,
  array,
  string,
  collection,
  boolean,
} from '@gogame/schemas';

import {
  FILTER_PERIOD,
  FILTER_PAY_TO,
  FILTER_GENRES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_CLUSTERS,
  FILTER_AFFILIATES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_CAMPAIGNS,
  FILTER_MANAGERS,
  FILTER_COUNTRIES,
  FILTER_OWNERS,
  FILTER_LABELS,
  FILTER_PLATFORMS,
  FILTER_CLIENTS,
  FILTER_TRAFFIC_TYPE,
  FILTER_TRAFFIC_TYPE_ADVERTISING,
  FILTER_INCLUDE_ARCHIVED,
  FILTER_CHANNELS,
  FILTER_REGISTRATION_TYPE,
  FILTER_CHANNEL_TYPE,
  REGISTRATION,
  FILTER_REAL_CP_FLOWS,
  FILTER_REAL_COUNTRIES,
  FILTER_CAMPAIGNS_TYPES,
  FILTER_FRAUD_TYPE,
  FILTER_DEVICE_TYPE,
  EXCLUDE_FRAUD,
  FILTER_STATUSES,
  FILTER_RE_COUNTER_TYPES,
  FILTER_BRIEFS,
  FILTER_INFLUENCER_CHANNEL_GENDERS,
  FILTER_INFLUENCER_CHANNEL_SOCIAL_MEDIA_PLATFORMS,
  FILTER_INFLUENCER_CHANNEL_PRICES,
  FILTER_INFLUENCER_CHANNEL_SUBSCRIBERS,
  FILTER_INFLUENCER_CHANNEL_TOTAL_VIEWS,
  FILTER_CPE_LIVE_EVENTS,
  FILTER_CPE_LIVE_EVENT_TYPE,
} from 'scenes/Trackers/Tracker/constants';
import {
  getPayToForCompare,
  getPayToByPeriod,
  getPrevious,
} from 'scenes/Trackers/components/Filters/utils';
import { payToSchema } from 'scenes/Trackers/components/Filters/payToSchema';
import { periodSchema } from 'scenes/Trackers/components/Filters/periodSchema';

export const filtersSchema = object({
  [FILTER_PERIOD]: periodSchema,
  [FILTER_PAY_TO]: payToSchema,
  [FILTER_GENRES]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_RE_COUNTER_TYPES]: array(number()),
  [FILTER_NETWORKS]: array(number()),

  [FILTER_CLUSTERS]: array(number()),

  [FILTER_AFFILIATES]: array(number()),
  [FILTER_CAMPAIGNS]: array(number()),
  [FILTER_MANAGERS]: array(number()),
  [FILTER_OWNERS]: array(number()),
  [FILTER_COUNTRIES]: array(number()),

  [FILTER_LABELS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_CLIENTS]: array(number()),
  [FILTER_BUSINESS_PARTNERS]: array(number()),
  ...(isGoGameEnv
    ? {
        [FILTER_CPE_LIVE_EVENTS]: array(string()),
        [FILTER_TRAFFIC_TYPE]: number().default(
          FILTER_TRAFFIC_TYPE_ADVERTISING
        ),
      }
    : {}),
  [FILTER_INCLUDE_ARCHIVED]: boolean(),
  [FILTER_CHANNELS]: array(number()),
  [FILTER_REGISTRATION_TYPE]: number().default(REGISTRATION),
  [FILTER_CAMPAIGNS_TYPES]: array(number()),
  [FILTER_REAL_CP_FLOWS]: array(number()),
  [FILTER_REAL_COUNTRIES]: array(number()),
  [FILTER_CHANNEL_TYPE]: array(number()),
  [FILTER_STATUSES]: array(number()),

  [FILTER_FRAUD_TYPE]: number().default(EXCLUDE_FRAUD),
  [FILTER_DEVICE_TYPE]: array(number()),
  [FILTER_BRIEFS]: array(number()),

  [FILTER_INFLUENCER_CHANNEL_GENDERS]: array(number()),
  [FILTER_INFLUENCER_CHANNEL_SOCIAL_MEDIA_PLATFORMS]: array(number()),
  [FILTER_INFLUENCER_CHANNEL_PRICES]: array(number()),
  [FILTER_INFLUENCER_CHANNEL_SUBSCRIBERS]: array(number()),
  [FILTER_INFLUENCER_CHANNEL_TOTAL_VIEWS]: array(number()),
  [FILTER_CPE_LIVE_EVENT_TYPE]: number(),
})
  .concat(creativeFiltersSchema)
  .transform(({ ...value }) => {
    const period = value[FILTER_PERIOD];
    let payTo = value[FILTER_PAY_TO];

    if (!payTo) {
      payTo = period ? getPayToByPeriod(period) : undefined;
    }

    return {
      ...value,
      [FILTER_PAY_TO]: payTo,
    };
  });

export const EMPTY_FILTERS = [filtersSchema.default()];

export const compareSchema = filtersSchema.transform(({ ...value }) => {
  const period = getPrevious(value[FILTER_PERIOD]);
  return {
    ...value,
    [FILTER_PERIOD]: period,
    [FILTER_PAY_TO]: getPayToForCompare(period),
  };
});

export const filtersCollectionSchema =
  collection(filtersSchema).default(EMPTY_FILTERS);
